import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FEATURE_KEY, IChildUserRoleDetails, ISecurityManagementState } from './security-management.model';

export const selectSecurityManagementFeature = createFeatureSelector<ISecurityManagementState>(FEATURE_KEY);

export const selectSecuritySetState = createSelector(selectSecurityManagementFeature, (state) => state?.securitySets);

export const selectIsPar = createSelector(selectSecurityManagementFeature, (state) => (state?.demographicInfo as any)?.isPar);

// assign user role use
export const selectChildUserDetails = createSelector(
  selectSecurityManagementFeature,
  (state) => state?.demographicInfo
);

export const selectRoleAssignmentConfig = createSelector(
  selectSecurityManagementFeature,
  (state) => (state?.demographicInfo?.results as IChildUserRoleDetails)?.roleAssignmentConfig
);

export const selectAssignRoleModifierSection = createSelector(
  selectSecurityManagementFeature,
  (state) => state?.assignUserRole?.securityModifier
);

export const selectRoleLandingState = createSelector(
  selectSecurityManagementFeature,
  (state) => state?.landingPageRoleData
);

export const selectRoleTable = createSelector(
  selectSecurityManagementFeature,
  (state) => state?.assignUserRole?.roleAndFeatures
);

export const selectVcodeDataState = createSelector(selectSecurityManagementFeature, (state) => state?.vCodeData);

export const selectEachVcodeData = createSelector(selectSecurityManagementFeature, (state) => state?.eachVcodeData);

export const selectRoleDataViewPagePosition = createSelector(
  selectSecurityManagementFeature,
  (state) => state?.pagePosition
);

export const selectSubmissionDetails = createSelector(selectSecurityManagementFeature, (state) => {
  return state?.submissionDetails;
});

export const selectSubmissionState = createSelector(selectSecurityManagementFeature, (state) => state?.submissionState);

export const selectCurrentScreen = createSelector(selectSecurityManagementFeature, (state) => state?.currentScreen);

// // add user:
export const selectSearchResults = createSelector(
  selectSecurityManagementFeature,
  (state) => state?.addUserSearchResults
);

export const selectAddNewUserBtnState = createSelector(
  selectSecurityManagementFeature,
  (state) => state?.isAddNewUserBtnActive
);

export const selectAddUserSearch = createSelector(selectSecurityManagementFeature, (state) => state?.addUserSearchState);
export const selectAddUserPagePosition = createSelector(selectSecurityManagementFeature, (state) => state?.addUserSearchState?.addUserPagePosition);

// // edit user
export const selectEditUserSearchResult = createSelector(
  selectSecurityManagementFeature,
  (state) => state?.editUserSearchResults
);

export const selectExistingUserDemographic = createSelector(
  selectSecurityManagementFeature,
  (state) => state?.existingUserInfo
);
export const selectExistingUserSecuritySet = createSelector(
  selectSecurityManagementFeature,
  (state) => state?.existingUserInfo?.childUserInfo
);

// edit user remove action
export const selectEditUserAction = createSelector(
  selectSecurityManagementFeature,
  (state) => state?.editUserRemoveAction
);

export const selectEditUserActiveSetAction = createSelector(
  selectSecurityManagementFeature,
  (state) => state?.editUserActiveSet
);

export const selectListenAssignApiCall = createSelector(
  selectSecurityManagementFeature,
  (state) => state?.listenAssignRolesApi
);

export const selectGroupRoleApiCallsDone =  createSelector(
  selectSecurityManagementFeature,
  (state) => state?.groupRolesApiCallsdDone
)

export const selectPendindUsersState = createSelector(selectSecurityManagementFeature, (state) => state?.pendingUsers);